import { render, staticRenderFns } from "./createFolder.vue?vue&type=template&id=7921c7cd&scoped=true&"
import script from "./createFolder.vue?vue&type=script&lang=ts&"
export * from "./createFolder.vue?vue&type=script&lang=ts&"
import style0 from "./createFolder.vue?vue&type=style&index=0&id=7921c7cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7921c7cd",
  null
  
)

export default component.exports